<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col class="d-flex flex-column align-center" md="5">
          <div class="">
            <h3 class="title mb-3 text-center">Capture Feed (NIR CAM)</h3>
            <!-- <v-divider></v-divider> -->
          </div>
          <div>
            <video ref="vid01" width="640" height="480">
              <!-- <source src="@/assets/borewell_low.mp4" type="video/mp4"> -->
              <!-- <source src="@/assets/rbs_vid_yolo.mp4" type="video/mp4"> -->
              <!-- <source src="@/assets/elephant_dsrl.mp4" type="video/mp4"> -->
              <source src="@/assets/inside_coal_mine.mp4" type="video/mp4">
            </video>
          </div>
          <!-- <div class="d-flex align-center">
            <v-btn-toggle v-model="toggle_one" mandatory>
              <v-btn>
                RGB
              </v-btn>
              <v-btn>
                THERMAL
              </v-btn>
              <v-btn>
                IR
              </v-btn>
            </v-btn-toggle>
            <v-spacer></v-spacer>
            <div>
              <v-icon color="primary" small left>mdi-record-circle</v-icon>
              <span class="body-1">Recording</span>
            </div>
          </div> -->
          <!-- <v-img
            height="500"
            contain
            src="http://127.0.0.1:8000/stream"
            > -->
          <!-- :src="require('./../assets/'+images[toggle_one])" -->
          <!-- <div class="ma-3">
              <v-icon small color="green">
                mdi-circle
              </v-icon> <strong class="overline">
                LIVE (MAIN CAM)
              </strong>
            </div> -->
          <!-- </v-img> -->
        </v-col>
        <v-col cols="7">
          <div class="mt-5">
            <v-row no-gutters>
              <v-col align-self="center" md="2">
                <div class="text-center mt-4">
                  <v-icon color="primary" x-large>
                    {{ motorRunning ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off-outline' }}
                  </v-icon>
                  <div class="text-center mt-4">
                    <div class="mt-1 body-2 grey--text">
                      Status
                    </div>
                    <div class="mt-2 body-1 font-weight-bold">
                      {{ motorRunning ? 'RUNNING' : 'STOPPED' }}
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col align-self="center" md="2">
                <div class="text-center mt-4">
                  <v-icon color="primary" x-large>
                    {{ isForward ? 'mdi-arrow-right-bold' : 'mdi-arrow-left-bold' }}
                  </v-icon>
                  <div class="text-center mt-4">
                    <div class="mt-1 body-2 grey--text">
                      Direction
                    </div>
                    <div class="mt-2 body-1 font-weight-bold">
                      {{ isForward ? 'FORWARD' : 'REVERSE' }}
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col align-self="center" md="2">
                <div class="text-center mt-4 pt-5">
                  <v-icon color="primary" x-large>
                    mdi-grain
                  </v-icon>
                  <div class="text-center mt-4">
                    <div class="mt-1 body-2 grey--text">
                      Mode
                    </div>
                    <div class="mt-2 body-1 font-weight-bold">
                      SMART
                    </div>
                  </div>
                </div>
                <v-divider vertical></v-divider>
              </v-col>
              <v-col md="2">
                <div class="text-center mt-4">
                  <v-progress-circular :rotate="90" :size="100" :width="15" color="primary" :value="speed">
                    <span class="title font-weight-bold">
                      {{ speed }}
                    </span>
                  </v-progress-circular>
                  <div class="text-center mt-4">
                    <div class="mt-2 body-1 font-weight-bold">
                      SPEED
                    </div>
                    <div class="mt-1 body-2 grey--text">
                      Kms/hr
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col md="2">
                <div class="text-center mt-4">
                  <v-progress-circular :rotate="90" :size="100" :width="15" color="primary" :value="rev">
                    <span class="title font-weight-bold">
                      {{ rev * 25 }}
                    </span>
                  </v-progress-circular>
                  <div class="text-center mt-4">
                    <div class="mt-2 body-1 font-weight-bold">
                      REV
                    </div>
                    <div class="mt-1 body-2 grey--text">
                      RPM
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col md="2">
                <div class="text-center mt-4">
                  <v-progress-circular :rotate="90" :size="100" :width="15" color="primary" :value="45">
                    <span class="title font-weight-bold">
                      68%
                    </span>
                  </v-progress-circular>
                  <div class="text-center mt-4">
                    <div class="mt-2 body-1 font-weight-bold">
                      Battery
                    </div>
                    <div class="mt-1 body-2 grey--text">
                      2:20 hrs left
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col md="12" class="pt-4">
                <v-card class="ma-3 pr-5" outlined>
                  <v-card-text>
                    <h4 class="overline d-flex align-center mb-4 justify-center">
                      <v-icon color="grey" small left>mdi-gamepad-circle</v-icon>
                      <span>CONTROL PANEL</span>
                    </h4>
                    <div>
                      <v-row no-gutters>
                        <v-col md="4" class="pa-4 pl-0">
                          <v-row no-gutters>
                            <v-col md="12">
                              <p class="mb-3">Movement</p>
                            </v-col>
                            <v-col class="pr-1" md="6">
                              <v-btn :disabled="motorRunning" @click="changeMotorState('start')" block><v-icon
                                  left>mdi-power</v-icon>START</v-btn>
                            </v-col>
                            <v-col class="pl-1" md="6">
                              <v-btn :disabled="!motorRunning" @click="changeMotorState('stop')" block
                                color="primary"><v-icon left>mdi-power-off</v-icon>STOP</v-btn>
                            </v-col>
                            <v-col class="pt-2" md="12">
                              <v-btn :disabled="!motorRunning" @click="changeMotorState('switch')" block
                                color="primary"><v-icon left>mdi-swap-horizontal</v-icon>
                                SWITCH DIRECTION
                              </v-btn>
                            </v-col>
                          </v-row>
                          <!-- <v-divider vertical></v-divider> -->
                        </v-col>
                        <v-col cols="4" class="pa-4">
                          <p class="mb-4">Speed</p>

                          <v-btn-toggle v-model="speedVal" color="primary" borderless rounded>
                            <v-btn value="low">
                              <v-icon left>
                                mdi-speedometer-slow
                              </v-icon>
                              <span class="hidden-sm-and-down">LOW</span>
                            </v-btn>

                            <v-btn value="med">
                              <v-icon left>
                                mdi-speedometer-medium
                              </v-icon>
                              <span class="hidden-sm-and-down">MED</span>
                            </v-btn>

                            <v-btn value="high">
                              <v-icon left>
                                mdi-speedometer
                              </v-icon>
                              <span class="hidden-sm-and-down">HIGH</span>
                            </v-btn>
                          </v-btn-toggle>
                        </v-col>
                        <!-- <v-divider vertical></v-divider> -->
                        <v-col cols="4" class="pa-4">
                          <p class="mb-4">Power Profile</p>

                          <v-btn-toggle v-model="powerVal" color="primary" borderless rounded>
                            <v-btn value="low">
                              <v-icon left>
                                mdi-sprout
                              </v-icon>
                              <span class="hidden-sm-and-down">ECO</span>
                            </v-btn>

                            <v-btn value="med">
                              <v-icon left>
                                mdi-grain
                              </v-icon>
                              <span class="hidden-sm-and-down">SMART</span>
                            </v-btn>

                            <v-btn value="high">
                              <v-icon left>
                                mdi-flash
                              </v-icon>
                              <span class="hidden-sm-and-down">TURBO</span>
                            </v-btn>
                          </v-btn-toggle>
                        </v-col>
                        <!-- <v-col md="4">
                          <v-row>                            
                            <v-col md="12">
                              <v-btn @click="changeMotorState('switch')" block color="primary"><v-icon left>mdi-swap-horizontal</v-icon>
                                SWITCH DIRECTION
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col> -->
                      </v-row>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col md="4">
                <v-card class="ma-3" outlined>
                  <v-card-text>
                    <h4 class="overline d-flex align-center">
                      <v-icon color="grey" small left>mdi-thermometer</v-icon>
                      <span>TEMPERATURE</span>
                    </h4>
                    <h5 class="display-1 font-weight-bold d-inline text--primary">
                      67°
                    </h5> <span>Celsius</span>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col md="4">
                <v-card class="ma-3" outlined>
                  <v-card-text>
                    <h4 class="overline d-flex align-center">
                      <v-icon color="grey" small left>mdi-triangle-down</v-icon>
                      <span>POSITION</span>
                    </h4>
                    <h5 class="display-1 font-weight-bold d-inline text--primary">
                      40° 41′ 17.57″ N
                    </h5> <span class="text-truncate"></span>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col md="4">
                <v-card class="ma-3" outlined>
                  <v-card-text>
                    <h4 class="overline d-flex align-center">
                      <v-icon color="grey" small left>mdi-elevator-down</v-icon>
                      <span>Runtime</span>
                    </h4>
                    <h5 class="display-1 font-weight-bold d-inline text--primary">
                      27
                    </h5> <span>HRS</span>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-col>
        <!-- <v-col md="6" offset-md="6">
          <div class="mx-3">
            <h3 class="title">Actions</h3>
            <div>
              <v-switch v-model="isMicActive" inset label="Mic On"></v-switch>
              <v-btn @click="micDialogOpen = true" :disabled="!isMicActive">START BROADCAST</v-btn>
            </div>
          </div>
        </v-col> -->
      </v-row>
    </v-container>

    <v-dialog v-model="micDialogOpen" height="" width="500">
      <v-card>
        <div class="text-center pt-10">
          <v-icon color="primary" x-large>
            mdi-microphone
          </v-icon>
        </div>
        <v-card-title class="headline justify-center">
          Secure Broadcast Started
        </v-card-title>
        <v-card-text class="text-center">
          <h4 class="subtitle-2">
            Start speaking into the mic
          </h4>
          <div class="text-center">
            <v-icon x-large>mdi-dots-horizontal</v-icon>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Graph from './../components/Graph.vue'
import axios from 'axios'

export default {
  data: () => ({
    toggle_one: 0,
    isMicActive: false,
    micDialogOpen: false,
    speedVal: 'med',
    powerVal: 'med',
    images: ['detection_03.jpg', 'detection_03_thermal.jpg', 'detection_03_IR.jpg'],
    motorRunning: false,
    speed: 0,
    rev: 0,
    interval: null,
    isForward: true,
    vidRef: null,
    
  }),
  mounted() {
    this.vidRef = this.$refs.vid01
  },
  methods: {
    async changeMotorState(mode) {
      if (!!this.interval) { clearInterval(this.interval) }

      if (mode == 'switch') {
        this.isForward = !this.isForward
      }

      if (mode == 'start' || mode == 'switch') {
        this.motorRunning = true
        this.vidRef.play()

        this.interval = setInterval(() => {
          let arr = this.generateRandomArray()
          this.speed = arr[0]
          this.rev = arr[1]
        }, 700)

      } else {
        this.motorRunning = false
        this.rev = 0
        this.speed = 0

        this.vidRef.pause()
      }
      try {
        const res = await axios.post('http://192.168.137.196:8000/?cmd=' + mode)
        console.log("Run mode changed. ", res.data)
      } catch (error) {
        console.log("An error occured. ", error)
      }

      this.$forceUpdate()
    },
    generateRandomArray() {
      const firstElementOptions = [34, 35, 36];
      const secondElementOptions = [44, 45, 46];

      const randomFirstElement = firstElementOptions[Math.floor(Math.random() * firstElementOptions.length)];
      const randomSecondElement = secondElementOptions[Math.floor(Math.random() * secondElementOptions.length)];

      return [randomFirstElement, randomSecondElement];
    }
  },
  components: {
    Graph
  }
}
</script>